import React from "react";
import { CustomDetailsList } from "../../../shared";
import { Box, Chip, Stack } from "@mui/material";
import { convertDate } from "../../../utils";

export const DetailsComponent = ({ state }) => {
  const detailsColumn = [
    {
      title: "Name",
      accessor: "name",
    },
    {
      title: "Label",
      accessor: (val) => (val.label ? val.label : "-"),
    },
    {
      title: "Description",
      accessor: (val) => (val.description ? val.description : "-"),
    },
    {
      title: "Image",
      accessor: (val) => {
        return val.image_path ? (
          <Box
            component="img"
            src={val.image_path}
            alt="promo-image"
            sx={{ borderRadius: "8px", maxHeight: "200px", minHeight: "100px" }}
          />
        ) : (
          "-"
        );
      },
    },
    {
      title: "Type",
      accessor: "type",
    },
  ];

  const validityAndStoreDetailsColumn = [
    {
      title: "Start Date",
      accessor: (val) =>
        val.start_date
          ? convertDate({ date: val.start_date, format: "DD MMM YYYY" })
          : "-",
    },
    {
      title: "End Date",
      accessor: (val) =>
        val.end_date
          ? convertDate({ date: val.end_date, format: "DD MMM YYYY" })
          : "-",
    },
    {
      title: "Stores",
      accessor: (val) =>
        val.stores?.length > 0 ? (
          <Stack gap="8px" direction="row" flexWrap="wrap">
            {val.stores.map((store) => (
              <Chip size="medium" key={store.id} label={store.name} />
            ))}
          </Stack>
        ) : (
          "-"
        ),
    },
  ];

  return (
    <React.Fragment>
      <CustomDetailsList
        columns={detailsColumn}
        data={state.details}
        title="Details"
        marginBottom="0px"
        style={{
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        }}
      />

      <CustomDetailsList
        columns={validityAndStoreDetailsColumn}
        data={state.validityAndStoreDetails}
        title="Validity & Stores"
        style={{
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        }}
      />
    </React.Fragment>
  );
};
